import React from "react";
import { View, TouchableOpacity } from "react-native";

import Svg, {
  Path,
  G,
  Defs,
  ClipPath,
  Stop,
  Rect,
  Pattern,
  LinearGradient,
  RadialGradient,
} from "react-native-svg";

export default function GCalendarIcon(props) {
  const w = props.width || 30;
  const h = props.height || 30;
  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={props.style} {...props}>
      <Svg width={w} height={h} viewBox="0 0 30 30" fill="none">
        <G clipPath="url(#clip0_gcal)">
          <Path
            d="M26.154 0H3.8463C2.57128 0 1.53857 1.0327 1.53857 2.30768L1.58281 16.9231H28.4616V2.30768C28.4617 1.0327 27.429 0 26.154 0Z"
            fill="#C2C2C2"
          />
          <Rect
            x="-2.2124"
            y="3.07692"
            width="34.4238"
            height="16.938"
            fill="url(#pattern0)"
          />
          <Path
            d="M27.6923 4.61534H2.30768C1.0327 4.61534 0 5.64805 0 6.92307C0 7.03074 0.00770965 7.13652 0.0211477 7.23843L1.53844 16.923H28.4615L29.9788 7.23843C29.9923 7.13459 30 7.02881 30 6.92307C30 5.64805 28.9673 4.61534 27.6923 4.61534Z"
            fill="#3367D6"
          />
          <Path
            opacity="0.5"
            d="M27.6923 4.61534H2.30768C1.0327 4.61534 0 5.64805 0 6.92307C0 7.03074 0.00770965 7.13652 0.0211477 7.23843L1.53844 16.923H28.4615L29.9788 7.23843C29.9923 7.13459 30 7.02881 30 6.92307C30 5.64805 28.9673 4.61534 27.6923 4.61534Z"
            fill="#2A56C6"
          />
          <Path
            d="M29.225 26.7635L28.4616 16.9231H1.53849L0.775059 26.7635C0.771225 26.8173 0.769287 26.8692 0.769287 26.9231C0.769287 28.1981 1.80199 29.2308 3.07697 29.2308H26.9231C28.1981 29.2308 29.2308 28.1981 29.2308 26.9231C29.2308 26.8692 29.2289 26.8173 29.225 26.7635Z"
            fill="#4285F4"
          />
          <Path
            d="M1.53857 16.9231L13.8463 29.2308H29.2309V16.9231H1.53857Z"
            fill="url(#paint0_linear)"
          />
          <Path
            d="M2.30768 4.80767H27.6923C28.9404 4.80767 29.9558 5.79997 29.9962 7.03843C29.9981 6.99996 30 6.9615 30 6.92304C30 5.64802 28.9673 4.61536 27.6923 4.61536H2.30768C1.0327 4.61536 0 5.64806 0 6.92308C0 6.96154 0.00193818 7.00001 0.00383329 7.03847C0.0442336 5.79997 1.05962 4.80767 2.30768 4.80767Z"
            fill="white"
            fillOpacity="0.2"
          />
          <Path
            d="M26.9231 29.0384H3.07697C1.82891 29.0384 0.813521 28.0461 0.77312 26.8077C0.771182 26.8461 0.769287 26.8846 0.769287 26.9231C0.769287 28.1981 1.80199 29.2307 3.07697 29.2307H26.9231C28.1981 29.2307 29.2308 28.198 29.2308 26.9231C29.2308 26.8846 29.2289 26.8461 29.227 26.8077C29.1866 28.0461 28.1712 29.0384 26.9231 29.0384Z"
            fill="#1A237E"
            fillOpacity="0.2"
          />
          <Path
            d="M26.154 0H3.8463C2.57128 0 1.53857 1.0327 1.53857 2.30768V2.49039C1.54435 1.22114 2.57511 0.19231 3.8463 0.19231H26.154C27.429 0.19231 28.4617 1.22502 28.4617 2.49999V2.30768C28.4617 1.0327 27.429 0 26.154 0Z"
            fill="white"
            fillOpacity="0.2"
          />
          <Path
            d="M12.7424 16.7577C13.6174 16.3962 14.7443 15.4346 14.7443 13.9865C14.7443 11.7558 13.3116 10.3846 10.8982 10.3846C8.74815 10.3846 7.01547 11.7923 6.98471 13.8462H8.54624C8.56933 12.6462 9.38086 11.6596 10.8963 11.6596C12.3559 11.6596 13.179 12.4192 13.179 13.952C13.179 15.4847 12.0059 16.1924 10.5751 16.1924C10.0136 16.1924 9.48475 16.1924 9.48475 16.1924V17.4154C9.48475 17.4154 10.0886 17.4154 10.5751 17.4154C12.679 17.4154 13.3713 18.5078 13.3713 19.7751C13.3713 21.4328 12.3636 22.1981 10.904 22.1981C9.63283 22.1981 8.47513 21.5193 8.4405 20.002H6.86743C6.93475 22.4462 8.99245 23.4635 10.904 23.4635C13.1116 23.4635 14.9328 22.177 14.9328 19.7404C14.9366 17.775 13.5366 16.9904 12.7424 16.7577ZM21.6693 10.3846L17.1154 12.0192V13.4885L20.3847 12.3962V23.4615H21.9232V10.3846H21.6693Z"
            fill="#E1E1E1"
          />
          <G opacity="0.5">
            <Path
              opacity="0.5"
              d="M12.7424 16.7577C13.6174 16.3962 14.7443 15.4346 14.7443 13.9865C14.7443 11.7558 13.3116 10.3846 10.8982 10.3846C8.74815 10.3846 7.01547 11.7923 6.98471 13.8462H8.54624C8.56933 12.6462 9.38086 11.6596 10.8963 11.6596C12.3559 11.6596 13.179 12.4192 13.179 13.952C13.179 15.4847 12.0059 16.1924 10.5751 16.1924C10.0136 16.1924 9.48475 16.1924 9.48475 16.1924V17.4154C9.48475 17.4154 10.0886 17.4154 10.5751 17.4154C12.679 17.4154 13.3713 18.5078 13.3713 19.7751C13.3713 21.4328 12.3636 22.1981 10.904 22.1981C9.63283 22.1981 8.47513 21.5193 8.4405 20.002H6.86743C6.93475 22.4462 8.99245 23.4635 10.904 23.4635C13.1116 23.4635 14.9328 22.177 14.9328 19.7404C14.9366 17.775 13.5366 16.9904 12.7424 16.7577ZM21.6693 10.3846L17.1154 12.0192V13.4885L20.3847 12.3962V23.4615H21.9232V10.3846H21.6693Z"
              fill="#C2C2C2"
            />
          </G>
          <Path
            d="M12.7424 16.7577C13.6174 16.3962 14.7443 15.4346 14.7443 13.9865C14.7443 11.7558 13.3116 10.3846 10.8982 10.3846C8.74815 10.3846 7.01547 11.7923 6.98471 13.8462H8.54624C8.56933 12.6462 9.38086 11.6596 10.8963 11.6596C12.3559 11.6596 13.179 12.4192 13.179 13.952C13.179 15.4847 12.0059 16.1924 10.5751 16.1924C10.0136 16.1924 9.48475 16.1924 9.48475 16.1924V17.4154C9.48475 17.4154 10.0886 17.4154 10.5751 17.4154C12.679 17.4154 13.3713 18.5078 13.3713 19.7751C13.3713 21.4328 12.3636 22.1981 10.904 22.1981C9.63283 22.1981 8.47513 21.5193 8.4405 20.002H6.86743C6.93475 22.4462 8.99245 23.4635 10.904 23.4635C13.1116 23.4635 14.9328 22.177 14.9328 19.7404C14.9366 17.775 13.5366 16.9904 12.7424 16.7577ZM21.6693 10.3846L17.1154 12.0192V13.4885L20.3847 12.3962V23.4615H21.9232V10.3846H21.6693Z"
            fill="#EEEEEE"
          />
          <Path
            d="M8.36757 4.61538L6.8772 3.12311L8.50798 1.49232L11.633 4.61538H8.36757Z"
            fill="url(#paint1_linear)"
          />
          <Path
            d="M7.69244 3.46155C8.3297 3.46155 8.8463 2.94495 8.8463 2.30769C8.8463 1.67043 8.3297 1.15382 7.69244 1.15382C7.05518 1.15382 6.53857 1.67043 6.53857 2.30769C6.53857 2.94495 7.05518 3.46155 7.69244 3.46155Z"
            fill="#EEEEEE"
          />
          <Path
            d="M7.69244 1.34714C8.29822 1.34714 8.79242 1.81252 8.84053 2.40483C8.84436 2.37214 8.8463 2.34138 8.8463 2.30869C8.8463 1.67215 8.32898 1.15483 7.69244 1.15483C7.0559 1.15483 6.53857 1.67215 6.53857 2.30869C6.53857 2.34138 6.54051 2.37214 6.54435 2.40483C6.59246 1.81252 7.08669 1.34714 7.69244 1.34714Z"
            fill="white"
            fillOpacity="0.4"
          />
          <Path
            d="M8.84053 2.40387C8.79246 2.99618 8.29629 3.46156 7.69244 3.46156C7.08859 3.46156 6.59246 2.99618 6.54435 2.40387C6.54051 2.43656 6.53857 2.46731 6.53857 2.5C6.53857 3.13654 7.0559 3.65387 7.69244 3.65387C8.32898 3.65387 8.8463 3.13654 8.8463 2.5C8.8463 2.46731 8.84436 2.43656 8.84053 2.40387Z"
            fill="#212121"
            fillOpacity="0.1"
          />
          <Path
            d="M28.6539 16.9231H1.34619V17.1154H28.6539V16.9231Z"
            fill="white"
            fillOpacity="0.05"
          />
          <Path
            d="M28.6539 16.7308H1.34619V16.9231H28.6539V16.7308Z"
            fill="#1A237E"
            fillOpacity="0.05"
          />
          <Path
            d="M22.9828 4.61538L21.4924 3.12311L23.1232 1.49232L25.479 4.61538H22.9828Z"
            fill="url(#paint2_linear)"
          />
          <Path
            d="M22.3082 3.46155C22.9454 3.46155 23.462 2.94495 23.462 2.30769C23.462 1.67043 22.9454 1.15382 22.3082 1.15382C21.6709 1.15382 21.1543 1.67043 21.1543 2.30769C21.1543 2.94495 21.6709 3.46155 22.3082 3.46155Z"
            fill="#EEEEEE"
          />
          <Path
            d="M22.3082 1.34714C22.9139 1.34714 23.4081 1.81252 23.4562 2.40483C23.4582 2.37214 23.462 2.34138 23.462 2.30869C23.462 1.67215 22.9447 1.15483 22.3082 1.15483C21.6716 1.15483 21.1543 1.67215 21.1543 2.30869C21.1543 2.34138 21.1562 2.37214 21.1601 2.40483C21.2081 1.81252 21.7024 1.34714 22.3082 1.34714Z"
            fill="white"
            fillOpacity="0.4"
          />
          <Path
            d="M23.4558 2.40387C23.4077 2.99618 22.9115 3.46156 22.3077 3.46156C21.7038 3.46156 21.2077 2.99618 21.1596 2.40387C21.1576 2.43656 21.1538 2.46731 21.1538 2.5C21.1538 3.13654 21.6711 3.65387 22.3077 3.65387C22.9442 3.65387 23.4615 3.13654 23.4615 2.5C23.4615 2.46731 23.4596 2.43656 23.4558 2.40387Z"
            fill="#212121"
            fillOpacity="0.1"
          />
          <Path
            d="M30 6.92309C30 5.91924 29.3577 5.0673 28.4616 4.75V2.30768C28.4616 1.0327 27.4289 0 26.1538 0H3.84617C2.57115 0 1.53844 1.0327 1.53844 2.30768L1.54421 4.74613C0.646146 5.06153 0 5.91537 0 6.92309C0 7.03077 0.00770965 7.13655 0.0211477 7.23845L1.53844 16.9231L0.775013 26.7635C0.77118 26.8173 0.769242 26.8692 0.769242 26.9231C0.769242 28.1981 1.80195 29.2308 3.07692 29.2308H26.9231C28.1981 29.2308 29.2308 28.1981 29.2308 26.9231C29.2308 26.8692 29.2288 26.8173 29.225 26.7635L28.4615 16.9231L29.9788 7.23845C29.9923 7.13655 30 7.03077 30 6.92309Z"
            fill="url(#paint3_radial)"
            fillOpacity="0.05"
          />
        </G>
        <Defs>
          <Pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          ></Pattern>
          <LinearGradient
            id="paint0_linear"
            x1="8.5221"
            y1="10.0636"
            x2="21.131"
            y2="22.6725"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#1A237E" stopOpacity="0.2" />
            <Stop offset="1" stopColor="#1A237E" stopOpacity="0.02" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear"
            x1="7.67324"
            y1="2.29226"
            x2="9.16925"
            y2="3.78827"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#212121" stopOpacity="0.2" />
            <Stop offset="1" stopColor="#212121" stopOpacity="0.02" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear"
            x1="22.2883"
            y1="2.29447"
            x2="23.6001"
            y2="3.60626"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#212121" stopOpacity="0.2" />
            <Stop offset="1" stopColor="#212121" stopOpacity="0.02" />
          </LinearGradient>
          <RadialGradient
            id="paint3_radial"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(2.05976 0.645882) scale(38.5084)"
          >
            <Stop offset="0.33" stopColor="white" />
            <Stop offset="1" stopColor="white" stopOpacity="0" />
          </RadialGradient>
          <ClipPath id="clip0_gcal">
            <Rect width="30" height="29.2308" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TAG>
  );
}
